export default __webpack_public_path__ + "static/media/12.4d841b03.png";